import React from 'react';
import { connect } from 'react-redux';
import DropdownItem from '@/components/DropdownItem';
import ToolsMenu from '@/components/tools/ToolsMenu';
import { copyDictionaryField, deleteDictionaryField } from '../../dictionaries/actions';

const DictionaryFieldTools = ({
  code,
  category,
  dictionaryUUID,
  fieldUUID,
  deleteField,
  copyField,
  listItem = false,
  upward,
  template,
}) => (
  <ToolsMenu listItem={listItem} upward={upward}>
    <DropdownItem
      icon="clone"
      textId="actions.duplicate"
      onClick={() => copyField(category, code, dictionaryUUID, fieldUUID, template)}
    />
    <DropdownItem
      className="delete-file"
      icon="trash alternate"
      textId="actions.delete"
      onClick={() => deleteField(category, code, dictionaryUUID, fieldUUID, template)}
    />
  </ToolsMenu>
);

const mapDispatchToProps = {
  copyField: copyDictionaryField,
  deleteField: deleteDictionaryField,
};

export default connect(null, mapDispatchToProps)(DictionaryFieldTools);
